import ReactTooltip from 'react-tooltip'
import { useSelector, useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import CoachDashboardScheduleSessionCard from './CoachDashboardScheduleSessionCard'
import EmptySchedule from './EmptySchedule'
import CoachDashboardScheduleEventCard from './CoachDashboardScheduleEventCard'
import { getScheduleSessionsByMonth } from '../../../actions/scheduleSessionActions'
import { getEventsByMonth } from '../../../actions/eventActions'
import { selectedDateEvents, selectedDateSessions } from '../../../reducers/dashboardReducer'
import { ReactComponent as InfoIcon } from '../../../assets/images/common/icons/info-circle-icon-dark.svg'
import styles from './CoachDashboardSchedule.module.scss'

const CoachDashboardSchedule = () => {
  const { t } = useTranslation()
  const { sessionsByMonth, selectedDate, eventsByMonth, selectedMonthDate, activeCourses } = useSelector(state => state.dashboard)
  const events = useSelector(selectedDateEvents)
  const sessions = useSelector(selectedDateSessions)
  const dispatch = useDispatch()
  const noPrograms = activeCourses?.length === 0 && events.length === 0

  useEffect(() => {
    if (!sessionsByMonth[selectedMonthDate.getMonth()] && !eventsByMonth[selectedMonthDate.getMonth()]) {
      dispatch(getScheduleSessionsByMonth({ selectedMonthDate }))
      dispatch(getEventsByMonth({ selectedMonthDate }))
    }
  }, [dispatch, eventsByMonth, selectedMonthDate, sessionsByMonth])


  const getSchduleTitle = () => {
    if (new Date().toDateString() === selectedDate.toDateString()){
      return t('dashboard.coach.coachDashboardSchedule.todaysScheduleTitle')
    } else {
      return t('dashboard.coach.coachDashboardSchedule.dateScheduleTitle', { date: moment(selectedDate).format('MMMM Do') })
    }
  }

  return (
    <div className={styles.coachDashboardSchedule}>
      <div className={styles.scheduleTitle}>
        <p className={styles.scheduleTitleText}>{getSchduleTitle()}</p>
        <InfoIcon data-for='infoTooltip' data-tip/>
        <ReactTooltip id='infoTooltip'
          effect='solid'
          delayUpdate={5}
          delayHide={5}
          place={'top'}
          className={styles.infoTooltip}
        ><p>{t('dashboard.coach.coachDashboardSchedule.infoTooltip')}</p></ReactTooltip>
      </div>
      {noPrograms ?
        <EmptySchedule
          title={t('dashboard.coach.coachDashboardSchedule.noActiveProgramsTitle')}
          text={t('dashboard.coach.coachDashboardSchedule.noActiveProgramsText')}
          noActivePrograms={noPrograms}
        />
        :
        sessions.length === 0 && events.length === 0 ? (
          <EmptySchedule
            title={t('dashboard.coach.coachDashboardSchedule.noProgramsTodayTitle')}
            text={t('dashboard.coach.coachDashboardSchedule.noProgramsTodayText')}
          />
        ) : (
          <>
            {sessions.map((session, index) =>
              <CoachDashboardScheduleSessionCard key={index} session={session}/>
            )}
            {events.map((e, index) =>
              <CoachDashboardScheduleEventCard key={index} event={e}/>
            )}
          </>
        )
      }
    </div>
  )
}

export default CoachDashboardSchedule
